<template lang="html">
    <div class="mailHolder bg-color-6 lightest d-flex justify-content-center" :class="{'closed': isClosed}">
        <i class="closeIcon pointer fas fa-times-circle" @click="close"></i>
        <div class="centerHolder py-3">
            <span>For the best experience please use a modern web browser like Microsoft Edge, <a class="underlined" href="https://www.google.com/chrome/" target="_blank">Google Chrome</a> or <a class="underlined" href="https://www.mozilla.org/firefox/" target="_blank">Firefox</a>.</span>
        </div>
    </div>
</template>

<script>
export default {
    data: function () {
        return {
            isClosed: false
        }
    },
    methods: {
        close: function () {
            let vm = this
            this.isClosed = true
            setTimeout(function () {
                vm.$emit('close')
            }, 350);
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/_variables';

.mailHolder{
    // position: absolute;
    position: relative;
    max-height: 100px;
    overflow: hidden;
    transition: all 300ms ease-in-out;

    &.closed{
        max-height: 0;
    }

    .closeIcon{
        position: absolute;
        top: 0.5rem;
        right: 0;
    }

    .centerHolder{

    }
}
</style>



// WEBPACK FOOTER //
// noInternetExplorer.vue?56633b07